module.exports = __webpack_public_path__ + "img/uk-cancer-female.f08e20ab.png";